import React,{useState,useEffect} from 'react'
import classNames from 'classnames'
require('./index.less')

const Index = (props: { type: string; className?: string; style?: any; onClick?: any }) => {

  const [isClientSide, setIsClientSide] = useState(false)
  useEffect(()=>{
    setIsClientSide(true)
  },[])
  return isClientSide&&(
    <svg
      className={classNames('icon', `${props.className || ''}`)}
      aria-hidden="true"
      style={props.style}
      onClick={props.onClick}
    >
      <use xlinkHref={`#${props.type}`} />
    </svg>
  )
}
export default Index
